<template>
  <section class="first-stop-account-card">
    <div class="first-stop-account-card__top">
      <h2 class="first-stop-account-card__title">{{ $t("portalHome.account.title") }}</h2>
      <img
        class="first-stop-account-card__brand"
        :src="firstStopBrandSrc"
        alt=""
      />
    </div>

    <div class="first-stop-account-card__middle">
      <p class="first-stop-account-card__points">
        {{ balanceGrouped }}
        <span class="first-stop-account-card__points-unit">{{ $t("portalHome.units.points") }}</span>
      </p>

      <p class="first-stop-account-card__updated">
        {{ $t("portalHome.account.lastUpdate", { date: account.updatedAt }) }}
      </p>
    </div>

    <div class="first-stop-account-card__actions">
      <button type="button" class="first-stop-account-card__btn first-stop-account-card__btn--muted">
        {{ $t("portalHome.purchases.detailsButton") }}
      </button>
      <button type="button" class="first-stop-account-card__btn first-stop-account-card__btn--accent">
        {{ $t("portalHome.account.firstStopPanelButton") }}
      </button>
    </div>
  </section>
</template>

<script setup>
import { computed, defineProps } from "vue";

import firstStopBrandSrc from "@/assets/img/bonus/firststop.png";

const props = defineProps({
  account: { type: Object, required: true },
});

function formatPointsGrouped(value) {
  const n = Math.trunc(Number(value));
  if (!Number.isFinite(n)) return "0";
  const sign = n < 0 ? "-" : "";
  return sign + String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

const balanceGrouped = computed(() =>
  formatPointsGrouped(props.account.firstStopBalance ?? props.account.balance)
);
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/first-stop-account-card";
</style>
